import {Component, OnInit} from '@angular/core';
import {ToggleService} from './common/header/toggle.service';
import {CommonModule, ViewportScroller} from '@angular/common';
import {HeaderComponent} from './common/header/header.component';
import {FooterComponent} from './common/footer/footer.component';
import {Event, NavigationEnd, Router, RouterOutlet} from '@angular/router';
import {ApiAuthServices} from './services/auth.service';
import { NgxSpinnerModule } from 'ngx-spinner';

@Component({
    selector: 'app-root',
    imports: [RouterOutlet, CommonModule, HeaderComponent, NgxSpinnerModule],
    templateUrl: './app.html',
    styleUrls: ['./app.scss']
})
export class App {

    private previousUrl: string | null = null;

    isToggled = false;

    constructor(
        public router: Router,
        private toggleService: ToggleService,
        private viewportScroller: ViewportScroller,
        private authService: ApiAuthServices,
    ) {
        this.authService.initializeAutoRefreshToken();
        this.router.events.subscribe((event: Event) => {
            if (event instanceof NavigationEnd) {
                const currentUrl = event.urlAfterRedirects;
                if (this.previousUrl && this.previousUrl !== currentUrl) {
                    this.viewportScroller.scrollToPosition([0, 0]);
                }
                this.previousUrl = currentUrl;
            }
        });
        this.toggleService.isToggled$.subscribe(isToggled => {
            this.isToggled = isToggled;
        });
    }

    isLoginPage(): boolean {
        return this.router.url.includes('/login') || this.router.url.includes('/activate') || this.router.url.includes('/reset-password');
    }

}
